<template>
  <div class="bg-image-ingresar main__login">
    <nav class="w-full">
      <div class="pt-4 w-full flex justify-between px-2 md:px-10 lg:hidden block">
        <a class="logo__show" href="/">
          <img src="/favicon-blue.png" alt="logo" width="45" />
        </a>
      </div>
      <div class="nav-size lg:block hidden">
        <div class="flex justify-between items-center">
          <div>
            <!--
            <a class="main__logo__show" href="/">
              <img src="../../assets/img/Dashboard/logo-azul-sin-fondo.png" alt="logo nirex" class="h-7" />
            </a>
            -->
          </div>
          <!-- <div class="ml-4 flex items-center">
            <a href="https://nirex.la/"
              class="menu__button text-center uppercase inline-block text-white mr-3 no-underline font-semibold"
              target="_blank">Servicios</a>
            <a href="https://nirex.la/riders"
              class="menu__button text-center uppercase inline-block text-white mr-3 no-underline font-semibold"
              target="_blank">Riders</a>
            <a href="https://nirex.la/conecta-tu-tienda/"
              class="menu__button text-center uppercase inline-block text-white mr-3 no-underline font-semibold"
              target="_blank">Conecta tu tienda</a>
            <a href="https://nirex.la/nosotros"
              class="menu__button text-center uppercase inline-block text-white mr-3 no-underline font-semibold"
              target="_blank">Nosotros</a>
            <a href="https://nirex.la/faq"
              class="menu__button text-center uppercase inline-block text-white mr-3 no-underline font-semibold"
              target="_blank">FAQ</a>
            <a href="https://nirex.la/blog"
              class="menu__button text-center uppercase inline-block text-white mr-3 no-underline font-semibold"
              target="_blank">Blog</a>
            <a href="https://nirex.la/contacto"
              class="menu__button text-center uppercase inline-block text-white mr-3 no-underline font-semibold"
              target="_blank">Contacto</a>
            <span class="express__button text-center no-underline uppercase px-3 py-3 rounded-lg font-semibold">
              Gestionar mis pedidos
            </span>
            <span class="social-media">
              <a href="https://www.facebook.com/NirexEnvios/" class="flex items-center justify-center no-underline ml-3"
                target="_blank"><img src="../../assets/img/Icons/facebook_white.png" width="24" height="24"
                  alt="fb" /></a>
              <a href="https://www.instagram.com/nirex.mensajeria/"
                class="flex items-center justify-center no-underline ml-3" target="_blank"><img
                  src="../../assets/img/Icons/instagram_white.png" width="24" height="24" alt="fb" /></a>
              <a href="https://www.linkedin.com/company/nirex.pe/"
                class="flex items-center justify-center no-underline ml-3" target="_blank"><img
                  src="../../assets/img/Icons/linkedin_white.png" width="24" height="24" alt="fb" /></a>
            </span>
          </div> -->
        </div>
      </div>
    </nav>
    <main class="w-full options__container">
      <div class="content__forms">
        <div>
          <div class="options__header">.</div>
          <router-view />
        </div>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  name: "RootDashboard",
};
</script>

<style lang="scss" scoped>
.main__login {
  background: no-repeat top/cover url("/img/auth/Portada2.png");
}

.social-media {
  display: flex;

  @media only screen and (max-width: 992px) {
    display: none;
  }
}

.sidebar-link {
  z-index: 3;
}

.sidebar {
  display: none;

  @media only screen and (max-width: 992px) {
    display: block;
    margin: 0;
    padding: 0;
    z-index: 2;
    color: white;
  }
}

.nav-size {
  width: 88%;
  margin: 3% auto 0px auto;
}

.options__container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  margin-top: 3%;

  @media only screen and (max-width: 992px) {
    align-items: center;
    overflow-y: auto;
    margin-top: 5%;
  }
}

.bg-image-ingresar {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.options__header {
  width: 100%;
  background-color: #474D59;
  color: #474D59;
}

.options__header::before {
  @media only screen and (max-width: 992px) {
    content: "........................";
  }

  padding-bottom: 2px;
  padding-top: 1px;
  content: ".....................................";
  background-color: #0A50E6;
  color: #0A50E6;
}

.content__forms {
  height: 150%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 7%;

  @media (max-width: 1278px) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0;
    padding: 0 10px;
  }
}

.express__button {
  background-color: #0A50E6;
  color: #73c9ff;
  border-radius: 0px;
  margin-left: -100px;
  display: none;

  @media (min-width: 768px) {
    margin-left: 0px;
    font-size: 0.8rem;
    display: block;
  }
}

.menu__button {
  display: none;
  font-size: 0.82rem;

  @media (min-width: 850px) {
    display: block;
  }

  &:hover {
    color: #73c9ff;
    background-color: #0A50E6;
    padding: 10px;
  }
}

.logo__show {
  @media screen and (max-width: 626px) {
    display: block;
  }

  display: none;
}

.main__logo__show {
  width: 240px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

  @media screen and (max-width: 626px) {
    display: none;
  }

  display: block;
}
</style>
